





















import util from '../../lib/util'
import {
  Component,
  Vue,
  Inject,
  Prop,
  Emit,
  Watch
} from 'vue-property-decorator'
import AbpBase from '../../lib/abpbase'
@Component({
  components: {}
})
export default class HeadMenu extends AbpBase {
  name: string = 'headMenu'
  @Prop({ required: true, type: Array })
  menuList: Array<any>
  @Prop({ required: true, type: Array })
  siderList: Array<any>
  activeName = ''
  theme = 'dark'

  itemTitle(item: any): string {
    return this.L(item.meta.title)
  }
  Util(item: any) {
    if(item.permission === '') {
      return true
    }else {
      return util.abp.auth.hasPermission(item.permission)
    }
  }
  changeMenu(active: string) {
    let list = []
    this.menuList.forEach(item => {
      if (item.name === active) {
        list = item.children || []
      }
    })
    // console.log('ListList', list);
    this.$store.commit('app/changeSiderList', list)
    this.routeChange(list)
  }

  routeChange(list) {
    list.forEach((item, index) => {
      if (index == 0) {
        if (item.children && item.children.length > 0) {
          this.routeChange(item.children)
        } else {
          this.$router.push({ name: item.name })
        }
      }
    })
  }

  @Watch('menuList')
  menuChange(list: any) {
    this.activeNameChange(list)
  }

  @Watch('siderList')
  siderChange(list: any) {
    this.menuList.forEach(item => {
      if (item.children == list) {
        this.activeName = item.name
      }
    })
  }

  activeNameChange(list: any, parent?) {
    let valiate = list.some(item => {
      if (item.name == this.$route.name) {
        this.activeName = parent ? parent : item.name
        return true
      } else if (item.children && item.children.length > 0) {
        let parentName = parent ? parent : item.name
        this.activeNameChange(item.children, parentName)
      }
    })

    return valiate
  }
}
